import {MarketMapService} from "./service/MarketMapService";

import Components from "./components";

export default function(): string {
    const moduleName = "tfApp.dashboard.oms.components.widgets.market-map";
    return angular.module(moduleName, [Components(moduleName)])
                  .service(MarketMapService.id, MarketMapService)
                  .name;
}
